module.exports = {
    "xd": {
        "cartLevelApproval": {
            "7419071": {
                "orders": {
                    "12969723": {
                        "idOrder": 12969723,
                        "orderName": "2 Line Address (STAFF)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address (STAFF)",
                        "branchName": "LIV Sotheby\u0027s International Realty",
                        "agentName": "Ann  Woodman",
                        "usageEmail": "awoodman@livsothebysrealty.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address (STAFF) (#12969723)",
                        "quantity": 1000,
                        "subTotal": 105,
                        "dateCreated": "07\/19\/2022",
                        "deliveryService": "FEDEX_GROUND",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3036, "name": "SIR Standard Business Cards"},
                        "style": {"id": 97381, "name": "No Photo"},
                        "shippingCharge": "5.00",
                        "salesTax": 3.149999999999999911182158029987476766109466552734375,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12969723\/12969723b.jpg\u0026natural=600\u0026randstring=62d8117a9978a", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12969723\/12969723a.jpg\u0026natural=600\u0026randstring=62d8117a9a023"],
                        "unitPrice": 105,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                }, "appliedPayments": {
                    "eligibleForBreakConsolidation": false,
                    "appliedCredits": {"promoCodes": [{"code": "333", expires: "2022-11-11", "itemId": 12985088, "amount": 10}]},
                    "appliedPayments": [], "shipping": {
                        "addressId": 565121,
                        "serviceLevel": "FEDEX_GROUND",
                        "shippingAddress": {
                            "idCompany": "102SOTHEBYSINTERNATI",
                            "idBranch": "39771FULLE",
                            "idAgent": null,
                            "idPrimary": 565121,
                            "dateCreated": {
                                "date": "2018-01-26 13:56:04.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "dateModified": {
                                "date": "2020-03-20 21:35:40.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "idEntity": "39771FULLE",
                            "isInternational": false,
                            "type": "office",
                            "isVisible": true,
                            "contactName": "OFFICE MANAGER",
                            "company": "LIV SOTHEBY\u0027S INTERNATIONAL REALTY",
                            "address1": "858 WEST HAPPY CANYON ROAD",
                            "address2": "SUITE 100",
                            "city": "CASTLE ROCK",
                            "state": "CO",
                            "postalCode": "80108",
                            "plus4": null,
                            "deliveryPoint": null,
                            "checkDigit": null,
                            "countryCode": "US",
                            "contactPhone": "303.893.3200",
                            "cassStatus": true,
                            "failed": false,
                            "errorCode": "",
                            "defaultBranch": true
                        },
                        "shippingCharge": 5,
                        "breakConsolidationCharge": 0,
                        "estimatedDeliveryDate": "2022-08-01 23:59:00",
                        "estimatedDeliveryMessage": "Between Mon, Aug 01, 2022 and Wed, Aug 03, 2022 by 11:59pm Local Time",
                        "breakShippingConsolidation": false
                    }
                }
            }, "6101244": {
                "orders": {
                    "12922491": {
                        "idOrder": 12922491,
                        "orderName": "2 Line Address FS (STAFF)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address FS (STAFF)",
                        "branchName": "Briggs Freeman Sotheby\u0027s International Realty",
                        "agentName": "Shelle  Carrig",
                        "usageEmail": "shelle@TEAM-tx.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address FS (STAFF) (#12922491)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/06\/2022",
                        "deliveryService": "GROUND_HOME_DELIVERY",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": "12.00",
                        "salesTax": 9.2400000000000002131628207280300557613372802734375,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/assets.awsdev.xpressdocs.com\/dserv\/tpl\/250\/1\/91008.jpg", "https:\/\/assets.awsdev.xpressdocs.com\/dserv\/tpl\/250\/2\/91008.jpg"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                }, "appliedPayments": {
                    "eligibleForBreakConsolidation": false,
                    "appliedCredits": {"promoCodes": [{"code": "111", expires: "2022-11-11", "itemId": 12985088, "amount": 10}]},
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "gdsyyf5",
                            "cardHolderName": "Michelle Carrig",
                            "cardLast4": "5683",
                            "amount": 121.2399999999999948840923025272786617279052734375
                        }]
                    },
                    "shipping": {
                        "addressId": 1037239,
                        "serviceLevel": "GROUND_HOME_DELIVERY",
                        "shippingAddress": {
                            "idCompany": "102SOTHEBYSINTERNATI",
                            "idBranch": "6ceaddc369",
                            "idAgent": "476888SHEL",
                            "idPrimary": 1037239,
                            "dateCreated": {
                                "date": "2022-06-10 14:55:44.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "dateModified": {
                                "date": "2022-06-10 14:55:44.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "idEntity": "476888SHEL",
                            "isInternational": false,
                            "type": "residential",
                            "isVisible": true,
                            "contactName": "SHELLE CARRIG",
                            "company": "BRIGGS FREEMAN SOTHEBY\u0027S INTL\u0027 REALTY",
                            "address1": "3131 TURTLE CREEK BLVD. 500",
                            "address2": "",
                            "city": "DALLAS",
                            "state": "TX",
                            "postalCode": "75219",
                            "plus4": null,
                            "deliveryPoint": null,
                            "checkDigit": null,
                            "countryCode": "US",
                            "contactPhone": "214-450-8782",
                            "cassStatus": true,
                            "failed": false,
                            "errorCode": "",
                            "defaultBranch": false
                        },
                        "shippingCharge": 12,
                        "breakConsolidationCharge": 0,
                        "estimatedDeliveryDate": "2022-08-06 23:59:00",
                        "estimatedDeliveryMessage": "Between Sat, Aug 06, 2022 and Mon, Aug 08, 2022 by 11:59pm Local Time",
                        "breakShippingConsolidation": false
                    }
                }
            }, "7424545": {
                "orders": {
                    "12979901": {
                        "idOrder": 12979901,
                        "orderName": "INTL 2 Line Address FS",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "INTL 2 Line Address FS",
                        "branchName": "Morocco Sotheby\u0027s International Realty",
                        "agentName": "Lara  Claessens",
                        "usageEmail": "lc@sothebysrealty.be",
                        "emailSubject": "Order Approvals for order: INTL 2 Line Address FS (#12979901)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": 0,
                        "salesTax": 8.25,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979901\/12979901b.jpg\u0026natural=600\u0026randstring=62da4ad054275", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979901\/12979901a.jpg\u0026natural=600\u0026randstring=62da4ad054e42"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    shipping: {
                        "serviceLevel": "PRIORITY_OVERNIGHT",
                    },
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "hjsn5gh",
                            "cardHolderName": "David Chicard",
                            "cardLast4": "6132",
                            "amount": 108.25
                        }]
                    }
                }
            }, "7424550": {
                "orders": {
                    "12979900": {
                        "idOrder": 12979900,
                        "orderName": "INTL 2 Line Address FS",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "INTL 2 Line Address FS",
                        "branchName": "Morocco Sotheby\u0027s International Realty",
                        "agentName": "Lara  Claessens",
                        "usageEmail": "lc@sothebysrealty.be",
                        "emailSubject": "Order Approvals for order: INTL 2 Line Address FS (#12979900)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": 0,
                        "salesTax": 8.25,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979900\/12979900b.jpg\u0026natural=600\u0026randstring=62da4b200f7cc", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979900\/12979900a.jpg\u0026natural=600\u0026randstring=62da4b20100c1"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "hjsn5gh",
                            "cardHolderName": "David Chicard",
                            "cardLast4": "6132",
                            "amount": 108.25
                        }]
                    }
                }
            }, "7424553": {
                "orders": {
                    "12979899": {
                        "idOrder": 12979899,
                        "orderName": "INTL 2 Line Address FS",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "INTL 2 Line Address FS",
                        "branchName": "Morocco Sotheby\u0027s International Realty",
                        "agentName": "Lara  Claessens",
                        "usageEmail": "lc@sothebysrealty.be",
                        "emailSubject": "Order Approvals for order: INTL 2 Line Address FS (#12979899)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": 0,
                        "salesTax": 8.25,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979899\/12979899b.jpg\u0026natural=600\u0026randstring=62da4b64a8dcd", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979899\/12979899a.jpg\u0026natural=600\u0026randstring=62da4b64a968f"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "hjsn5gh",
                            "cardHolderName": "David Chicard",
                            "cardLast4": "6132",
                            "amount": 108.25
                        }]
                    }
                }
            }, "7422850": {
                "orders": {
                    "12979920": {
                        "idOrder": 12979920,
                        "orderName": "2 Line Address FS (Int\u0027l Spec)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address FS (Int\u0027l Spec)",
                        "branchName": "Belgium Sotheby\u2019s International Realty",
                        "agentName": "Lara  Claessens",
                        "usageEmail": "lara.claessens@sothebysrealty.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address FS (Int\u0027l Spec) (#12979920)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": 0,
                        "salesTax": 8.25,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979920\/12979920b.jpg\u0026natural=600\u0026randstring=62da513ebc087", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979920\/12979920a.jpg\u0026natural=600\u0026randstring=62da513ebcafc"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    "eligibleForBreakConsolidation": false,
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "bnvhhrr",
                            "cardHolderName": "Castell Realty",
                            "cardLast4": "0281",
                            "amount": 108.25
                        }]
                    }
                }
            }, "7424556": {
                "orders": {
                    "12979919": {
                        "idOrder": 12979919,
                        "orderName": "2 Line Address FS (Int\u0027l Spec)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address FS (Int\u0027l Spec)",
                        "branchName": "Belgium Sotheby\u2019s International Realty",
                        "agentName": "Lara  Claessens",
                        "usageEmail": "lara.claessens@sothebysrealty.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address FS (Int\u0027l Spec) (#12979919)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": 0,
                        "salesTax": 8.25,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979919\/12979919b.jpg\u0026natural=600\u0026randstring=62da518db05e3", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979919\/12979919a.jpg\u0026natural=600\u0026randstring=62da518db0efb"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "bnvhhrr",
                            "cardHolderName": "Castell Realty",
                            "cardLast4": "0281",
                            "amount": 108.25
                        }]
                    }
                }
            }, "7424557": {
                "orders": {
                    "12979917": {
                        "idOrder": 12979917,
                        "orderName": "2 Line Address FS (Int\u0027l Spec)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address FS (Int\u0027l Spec)",
                        "branchName": "Belgium Sotheby\u2019s International Realty",
                        "agentName": "Lara  Claessens",
                        "usageEmail": "lara.claessens@sothebysrealty.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address FS (Int\u0027l Spec) (#12979917)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": 0,
                        "salesTax": 8.25,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979917\/12979917b.jpg\u0026natural=600\u0026randstring=62da51e5b10d3", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979917\/12979917a.jpg\u0026natural=600\u0026randstring=62da51e5b1966"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "bnvhhrr",
                            "cardHolderName": "Castell Realty",
                            "cardLast4": "0281",
                            "amount": 108.25
                        }]
                    }
                }
            }, "7424558": {
                "orders": {
                    "12979914": {
                        "idOrder": 12979914,
                        "orderName": "2 Line Address FS (Int\u0027l Spec)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address FS (Int\u0027l Spec)",
                        "branchName": "Belgium Sotheby\u2019s International Realty",
                        "agentName": "Lara  Claessens",
                        "usageEmail": "lara.claessens@sothebysrealty.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address FS (Int\u0027l Spec) (#12979914)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": 0,
                        "salesTax": 8.25,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979914\/12979914b.jpg\u0026natural=600\u0026randstring=62da5235d66d2", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12979914\/12979914a.jpg\u0026natural=600\u0026randstring=62da5235d6f23"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "bnvhhrr",
                            "cardHolderName": "Castell Realty",
                            "cardLast4": "0281",
                            "amount": 108.25
                        }]
                    }
                }
            }, "7426758": {
                "orders": {
                    "12964677": {
                        "idOrder": 12964677,
                        "orderName": "Maryanne Biz Cards",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "Agent Photo FS (STAFF)",
                        "branchName": "Nick Sadek Sotheby\u0027s International Realty",
                        "agentName": "Nick  Sadek",
                        "usageEmail": "nick.sadek@gmail.com",
                        "emailSubject": "Order Approvals for order: Maryanne Biz Cards (#12964677)",
                        "quantity": 500,
                        "subTotal": 115,
                        "dateCreated": "07\/18\/2022",
                        "deliveryService": "GROUND_HOME_DELIVERY",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97384, "name": "With Photo - Foil"},
                        "shippingCharge": "12.00",
                        "salesTax": 8.339999999999999857891452847979962825775146484375,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12964677\/12964677b.jpg\u0026natural=600\u0026randstring=62db32d002e6c", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12964677\/12964677a.jpg\u0026natural=600\u0026randstring=62db32d003976"],
                        "unitPrice": 115,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                }, "appliedPayments": {
                    "eligibleForBreakConsolidation": false,
                    "shipping": {
                        "addressId": 990166,
                        "serviceLevel": "GROUND_HOME_DELIVERY",
                        "shippingAddress": {
                            "idCompany": "102SOTHEBYSINTERNATI",
                            "idBranch": "c781d5ff76",
                            "idAgent": null,
                            "idPrimary": 990166,
                            "dateCreated": {
                                "date": "2021-11-23 18:07:00.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "dateModified": {
                                "date": "2021-11-23 18:07:00.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "idEntity": "c781d5ff76",
                            "isInternational": false,
                            "type": "residential",
                            "isVisible": true,
                            "contactName": "NICK SADEK",
                            "company": "NICK SADEK SOTHEBY\u0027S INTERNATIONAL REALTY",
                            "address1": "9217 SIERRA COLLEGE BLVD., STE. 120",
                            "address2": "",
                            "city": "ROSEVILLE",
                            "state": "CA",
                            "postalCode": "95661",
                            "plus4": null,
                            "deliveryPoint": null,
                            "checkDigit": null,
                            "countryCode": "US",
                            "contactPhone": "916-784-7444",
                            "cassStatus": true,
                            "failed": false,
                            "errorCode": "",
                            "defaultBranch": true
                        },
                        "shippingCharge": 12,
                        "breakConsolidationCharge": 0,
                        "estimatedDeliveryDate": "2022-08-05 23:59:00",
                        "estimatedDeliveryMessage": "Between Fri, Aug 05, 2022 and Tue, Aug 09, 2022 by 11:59pm Local Time",
                        "breakShippingConsolidation": false
                    },
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "2nwx2mt",
                            "cardHolderName": "Nick Sadek",
                            "cardLast4": "6670",
                            "amount": 135.340000000000003410605131648480892181396484375
                        }]
                    }
                }
            }, "7426737": {
                "orders": {
                    "12983845": {
                        "idOrder": 12983845,
                        "orderName": "Agent Color Photo FS (STAFF)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "Agent Color Photo FS (STAFF)",
                        "branchName": "Vintage Sotheby\u0027s International Realty",
                        "agentName": "Martha null Macias",
                        "usageEmail": "martha.macias@sothebysrealty.com",
                        "emailSubject": "Order Approvals for order: Agent Color Photo FS (STAFF) (#12983845)",
                        "quantity": 500,
                        "subTotal": 125,
                        "dateCreated": "07\/22\/2022",
                        "deliveryService": "GROUND_HOME_DELIVERY",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 145635, "name": "With Color Photo - Foil"},
                        "shippingCharge": "12.00",
                        "salesTax": 9.6899999999999995026200849679298698902130126953125,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12983845\/12983845b.jpg\u0026natural=600\u0026randstring=62db333ec2633", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12983845\/12983845a.jpg\u0026natural=600\u0026randstring=62db333ec2e2c"],
                        "unitPrice": 125,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                }, "appliedPayments": {
                    "eligibleForBreakConsolidation": false,
                    "shipping": {
                        "addressId": 1010215,
                        "breakShippingConsolidation": false,
                        "serviceLevel": "GROUND_HOME_DELIVERY",
                        "shippingAddress": {
                            "idCompany": "102SOTHEBYSINTERNATI",
                            "idBranch": "5ffb9589e4",
                            "idAgent": "ecd47e5d2f",
                            "idPrimary": 1010215,
                            "dateCreated": {
                                "date": "2022-02-23 11:52:12.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "dateModified": {
                                "date": "2022-02-23 11:52:13.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "idEntity": "ecd47e5d2f",
                            "isInternational": false,
                            "type": "residential",
                            "isVisible": true,
                            "contactName": "MARTHA MACIAS",
                            "company": "",
                            "address1": "2524 MACMILLAN ST",
                            "address2": "",
                            "city": "NAPA",
                            "state": "CA",
                            "postalCode": "94558",
                            "plus4": null,
                            "deliveryPoint": null,
                            "checkDigit": null,
                            "countryCode": "US",
                            "contactPhone": "707-704-5213",
                            "cassStatus": true,
                            "failed": false,
                            "errorCode": "",
                            "defaultBranch": false
                        },
                        "shippingCharge": 12,
                        "breakConsolidationCharge": 0,
                        "estimatedDeliveryDate": "2022-08-05 23:59:00",
                        "estimatedDeliveryMessage": "Between Fri, Aug 05, 2022 and Tue, Aug 09, 2022 by 11:59pm Local Time"
                    },
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "dvhx489",
                            "cardHolderName": "Martha Macias",
                            "cardLast4": "3122",
                            "amount": 146.68999999999999772626324556767940521240234375
                        }]
                    }
                }
            }, "7426850": {
                "orders": {
                    "12969933": {
                        "idOrder": 12969933,
                        "orderName": "2 Line Address FS (STAFF)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address FS (STAFF)",
                        "branchName": "Vintage Sotheby\u0027s International Realty",
                        "agentName": "Branch Order",
                        "usageEmail": "l.bertolucci@vintagesothebysrealty.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address FS (STAFF) (#12969933)",
                        "quantity": 500,
                        "subTotal": 100,
                        "dateCreated": "07\/19\/2022",
                        "deliveryService": "FEDEX_GROUND",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3046, "name": "SIR Foil Business Cards"},
                        "style": {"id": 97383, "name": "No Photo - Foil"},
                        "shippingCharge": "5.00",
                        "salesTax": 7.75,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12969933\/12969933b.jpg\u0026natural=600\u0026randstring=62db56df0dff9", "https:\/\/www.xpressdocs.com\/next\/proof_display.php?type=proof\u0026path=\/proofs\/12969933\/12969933a.jpg\u0026natural=600\u0026randstring=62db56df0e867"],
                        "unitPrice": 100,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                }, "appliedPayments": {
                    "eligibleForBreakConsolidation": false,
                    "shipping": {
                        "addressId": 1043240,
                        "serviceLevel": "FEDEX_GROUND",
                        "shippingAddress": {
                            "idCompany": "102SOTHEBYSINTERNATI",
                            "idBranch": "5ffb9589e4",
                            "idAgent": null,
                            "idPrimary": 1043240,
                            "dateCreated": {
                                "date": "2022-07-08 20:12:27.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "dateModified": {
                                "date": "2022-07-08 20:12:27.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "idEntity": "5ffb9589e4",
                            "isInternational": false,
                            "type": "office",
                            "isVisible": true,
                            "contactName": "LISA BERTOLUCCI",
                            "company": "VINTAGE SOTHEBY\u0027S INTERNATIONAL",
                            "address1": "6550 WASHINGTON ST",
                            "address2": "",
                            "city": "YOUNTVILLE",
                            "state": "CA",
                            "postalCode": "94599",
                            "plus4": null,
                            "deliveryPoint": null,
                            "checkDigit": null,
                            "countryCode": "US",
                            "contactPhone": "707-944-0888",
                            "cassStatus": true,
                            "failed": false,
                            "errorCode": "",
                            "defaultBranch": true
                        },
                        "shippingCharge": 5,
                        "breakConsolidationCharge": 0,
                        "estimatedDeliveryDate": "2022-08-05 23:59:00",
                        "estimatedDeliveryMessage": "Between Fri, Aug 05, 2022 and Tue, Aug 09, 2022 by 11:59pm Local Time",
                        "breakShippingConsolidation": false
                    },
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "8qmqfjr",
                            "cardHolderName": "Elisabeth Bertolucci",
                            "cardLast4": "3461",
                            "amount": 112.75
                        }]
                    }
                }
            }, "7427246": {
                "orders": {
                    "12985088": {
                        "idOrder": 12985088,
                        "orderName": "2 Line Address (STAFF)",
                        "orderType": "BusCard",
                        "photoCount": 0,
                        "templateName": "2 Line Address (STAFF)",
                        "branchName": "Demo Branch",
                        "agentName": "QA  Agent",
                        "usageEmail": "topcompamies2@test.com",
                        "emailSubject": "Order Approvals for order: 2 Line Address (STAFF) (#12985088)",
                        "quantity": 500,
                        "subTotal": 70,
                        "dateCreated": "07\/27\/2022",
                        "deliveryService": "FEDEX_2_DAY",
                        "expeditedProduction": false,
                        "category": {"id": 3035, "name": "Business Cards"},
                        "subCategory": {"id": 3036, "name": "SIR Standard Business Cards"},
                        "style": {"id": 97381, "name": "No Photo"},
                        "shippingCharge": "14.00",
                        "salesTax": 6.11000000000000031974423109204508364200592041015625,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/assets.awsdev.xpressdocs.com\/dserv\/tpl\/250\/1\/89117.jpg", "https:\/\/assets.awsdev.xpressdocs.com\/dserv\/tpl\/250\/2\/89117.jpg"],
                        "unitPrice": 70,
                        "approverLevel": "First Approver",
                        "isFlatRate": 1,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": false,
                        "proofEngineType": 7,
                        "orderCorrupt": false
                    }
                }, "appliedPayments": {
                    "eligibleForBreakConsolidation": false,

                    "paymentErrors": [],
                    "appliedCredits": {"promoCodes": [{"code": "222", expires: "2021-11-11", "itemId": 12985088, "amount": 10}]},
                    "shipping": {
                        "addressId": 881275,
                        "serviceLevel": "FEDEX_2_DAY",
                        "shippingAddress": {
                            "idCompany": "102SOTHEBYSINTERNATI",
                            "idBranch": "7341DEMOBR",
                            "idAgent": null,
                            "idPrimary": 881275,
                            "dateCreated": {
                                "date": "2020-10-06 23:58:32.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "dateModified": {
                                "date": "2020-10-06 23:58:32.000000",
                                "timezone_type": 3,
                                "timezone": "America\/Chicago"
                            },
                            "idEntity": "7341DEMOBR",
                            "isInternational": false,
                            "type": "office",
                            "isVisible": true,
                            "contactName": "DEMO BRANCH",
                            "company": "SOTHEBY\u0027S INTERNATIONAL REALTY",
                            "address1": "1301 NE LOOP 820",
                            "address2": "",
                            "city": "FORT WORTH",
                            "state": "TX",
                            "postalCode": "76131",
                            "plus4": null,
                            "deliveryPoint": null,
                            "checkDigit": null,
                            "countryCode": "US",
                            "contactPhone": "123-456-7890",
                            "cassStatus": true,
                            "failed": false,
                            "errorCode": "",
                            "defaultBranch": true
                        },
                        "shippingCharge": 14,
                        "breakConsolidationCharge": 0,
                        "estimatedDeliveryDate": "2022-08-08 16:30:00",
                        "estimatedDeliveryMessage": "Monday, Aug 08, 2022 by 4:30pm Local Time",
                        "breakShippingConsolidation": false
                    },
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "nmzbg76",
                            "cardHolderName": "test12541",
                            "cardLast4": "1111",
                            "amount": 80.1099999999999994315658113919198513031005859375
                        }],
                        // shipping: {
                        //     "serviceLevel": "FEDEX_2_DAY",
                        // },
                    }
                }
            }
        }
    }, "procurement": [], "oci": []
};